module.exports = __webpack_public_path__ + "static/img/wiseBrain01.8c9917a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/wiseBrain01.png
// module id = IDPj
// module chunks = 1